// extracted by mini-css-extract-plugin
module.exports = {"header":"heading-module--header--1BJ7c","title":"heading-module--title--3-Qd7","cover":"heading-module--cover--38kxN"};